import { Button, Popconfirm, notification } from 'antd';

import { apiClient } from '../../api/client/apiClient';

import { Integration } from './types';
import { INTEGRATIONS_API_URL } from './consts';

interface DeleteIntegrationProps {
  integration: Integration;
}

export const RunIntegration = ({ integration }: DeleteIntegrationProps) => {
  const onConfirm = async () => {
    try {
      await apiClient.post(`${INTEGRATIONS_API_URL}/integrations/spreadsheet`, {
        dataSource: integration.dataSource,
        type: integration.type,
        sheetName: integration.sheetName,
        spreadsheetId: integration.spreadsheetId,
        uuid: integration.uuid,
        dataSourceType: integration.dataSourceType,
      });
      notification.open({
        message: 'Integration',
        description: 'Integration has been successfully run',
      });
    } catch (error) {
      let errorMessage = 'Unknown error';
      if (error instanceof Error) {
        errorMessage = error.message;
      }
      notification.error({
        message: 'Integration',
        description: errorMessage,
      });
    }
  };

  return (
    <Popconfirm title="Are you sure to run this integration?" onConfirm={onConfirm} okText="Yes" cancelText="No">
      <Button style={{ borderColor: 'green', color: 'green' }}>Run</Button>
    </Popconfirm>
  );
};
